import { BoardViewModel } from '../interface/board/board-view-model';
import { SolitaireMainScene } from '../scenes/solitaire-main-scene';
import { GameServices } from '../game-services';
import { BoardView } from '../interface/board/board-view';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export class GameController {
  private readonly gameServices: GameServices;
  private readonly boardViewModel: BoardViewModel;
  private boardView?: BoardView;

  constructor(gameServices: GameServices) {
    this.gameServices = gameServices;
    this.boardViewModel = new BoardViewModel(gameServices);
  }

  public initGraphics(scene: SolitaireMainScene) {
    this.boardView = new BoardView(scene, 0, 0, this.boardViewModel);
    this.onResize(scene.currentGameSizeMetrics);
  }

  public onResize(gameSizeMetrics: GameSizeMetrics) {
    this.boardView?.onResize(gameSizeMetrics);
  }

  public onSceneReady() {
    this.gameServices.gameListenerService.onGameLoaded();

    if (this.gameServices.usingLocalDealer) {
      this.gameServices.gameRunnerService.createLocalGame();
    }
  }

  public showStartButton(showButton: boolean): void {
    this.boardViewModel.showStartButton(showButton);
  }

  public startRemoteRound(moves: string[]): void {
    if (moves.length > 0) {
      this.gameServices.gameRunnerService.startExistingRemoteRound(moves);
      return;
    }
    this.gameServices.gameRunnerService.startNewRemoteRound();
  }

  public hint(): void {
    this.gameServices.gameRunnerService.hint();
  }

  public undo(): void {
    this.gameServices.gameRunnerService.undo();
  }

  public setInstantFinish(): void {
    this.boardViewModel.setInstantFinish();
  }

  public autoStartGame(): void {
    this.gameServices.gameListenerService.onStartGame();
  }

  public resetGameScene(): void {
    this.boardViewModel.resetGameScene();
  }
}
